import { BrandChatTurnEvent } from '@storefronts/common-types'

/** Reads a turn's newline-delimited JSON events as they arrive. */
export async function* readTurnEvents(
    body: ReadableStream<Uint8Array>,
): AsyncGenerator<BrandChatTurnEvent> {
    const reader = body.getReader()
    const decoder = new TextDecoder()
    let buffered = ''
    for (;;) {
        const { value, done } = await reader.read()
        buffered += decoder.decode(value, { stream: !done })
        const lines = buffered.split('\n')
        buffered = lines.pop() ?? ''
        for (const line of lines) {
            if (line.trim()) yield JSON.parse(line) as BrandChatTurnEvent
        }
        if (done) break
    }
    if (buffered.trim()) yield JSON.parse(buffered) as BrandChatTurnEvent
}
